export default __webpack_public_path__ + "static/media/Maintenance-pana.37ea0651.svg";